import logoImg from '@/assets/images/home/logo-white.svg';
import eduIcon1 from '@/assets/images/home/edu-icon1.webp';
import eduIcon2 from '@/assets/images/home/edu-icon2.webp';
import eduIcon3 from '@/assets/images/home/edu-icon3.webp';
import secureIcon0 from '@/assets/images/home/secure-icon0.webp';

import eduIcon1png from '@/assets/images/home/edu-icon1.png';
import eduIcon2png from '@/assets/images/home/edu-icon2.png';
import eduIcon3png from '@/assets/images/home/edu-icon3.png';
import secureIcon0png from '@/assets/images/home/secure-icon0.png';

import secureIcon1 from '@/assets/images/home/secure-icon1.png';
import secureIcon2 from '@/assets/images/home/secure-icon2.png';
import secureIcon3 from '@/assets/images/home/secure-icon3.png';
import { common } from '@/common/constants/config';

export const bannerData = {
  title: '畅享一体化教学办公管理体验',
  logo: logoImg,
  subtitle:
    '「WPS 365 教育版」是金山办公面向教育行业专为校内“教学、管理、办公”等场景提供的数字化解决方案',
  buttonTxt: '下载教育版客户端',
  buttonEvent: 'down_load',
  url: 'https://edu-download.wpscdn.cn/cdn/wps/17133/WPS365Edu_office12.1.0.17133_integration_30.12013.exe',
  buttonTxt2: '申请体验',
  buttonEvent2: 'apply_try',
  
  url2: common.contactSales
};
export const workData = {
  title: '一站式的教学办公体验',
  subtitle:
    '适用于教育的新一代办公套件，为教师和学生提供更加便捷、高效的办公与学习体验',

  mSubtitle: '适用于教育的新一代办公套件',
  introduceList: [
    {
      name: 'neirong',
      title: '提高生产力',
      desc: '随时随地，轻松写作，无缝协作',
      subdesc:
        '提供易于使用的文档工具，让学校中每一个人都能在任何时间、任何地点轻松协作处理文档，从而简化任务并节省时间。',
      items: [
        {
          logo: require('@/assets/images/product/office.png'),
          reverseLogo: require('@/assets/images/product/office-r.png'),
          picture: require('@/assets/images/product/office-p.webp'),
          pngPicture: require('@/assets/images/product/office-p.png'),
          title: 'WPS Office',
          desc: '专业高效的Office工具，全平台覆盖，随时随地办公，支持文字、表格、演示等办公组件不同格式，支持PDF编辑与转换',
          link: 'https://platform.wps.cn',
          name: 'wps',
          weight: 100,
          event: 'wpsoffice',
          subicons: [
            require('@/assets/images/product/wps-format.png'),
            require('@/assets/images/product/wpp-format.png'),
            require('@/assets/images/product/et-format.png'),
            require('@/assets/images/product/pdf.png')
          ]
        },
        {
          logo: require('@/assets/images/product/pdf.png'),
          reverseLogo: require('@/assets/images/product/pdf-r.png'),
          picture: require('@/assets/images/product/pdf-p.webp'),
          pngPicture: require('@/assets/images/product/pdf-p.png'),
          title: 'WPS PDF',
          desc: '功能强大的PDF编辑器，轻巧简洁，多格式高效转换，各类内容自由编辑',
          link: 'https://www.wpspdf.cn',
          name: 'pdf',
          weight: 99,
          event: 'pdf',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/air-page.svg'),
          reverseLogo: require('@/assets/images/product/air-page-r.png'),
          picture: require('@/assets/images/product/air-page-p.webp'),
          pngPicture: require('@/assets/images/product/air-page-p.png'),
          title: '智能文档',
          desc: '新一代在线内容协作工具，容纳丰富的协作矩阵元素，实现更好的数据链转和消息管理',
          link: 'https://kdocs.cn',
          name: 'airpage',
          weight: 96,
          event: 'light_document',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/air-sheet.svg'),
          reverseLogo: require('@/assets/images/product/air-sheet-r.png'),
          picture: require('@/assets/images/product/air-sheet-p.webp'),
          pngPicture: require('@/assets/images/product/air-sheet-p.png'),
          title: '智能表格',
          desc: '新一代在线表格，数据规范、协作可控、过程可追溯，既能兼容普通表格打通数据，也能基于规范数据搭建轻流程/应用/系统',
          link: 'https://kdocs.cn',
          name: 'airsheet',
          weight: 95,
          event: 'light_table',
          subicons: []
        },

        {
          logo: require('@/assets/images/product/naotu.png'),
          reverseLogo: require('@/assets/images/product/naotu-r.png'),
          picture: require('@/assets/images/product/naotu-p.webp'),
          pngPicture: require('@/assets/images/product/naotu-p.png'),
          title: '流程图/脑图',
          desc: '重组碎片化信息，建立清晰的思维体系',
          link: '',
          event: 'flow',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/form.svg'),
          reverseLogo: require('@/assets/images/product/form-r.png'),
          picture: require('@/assets/images/product/form-p.webp'),
          pngPicture: require('@/assets/images/product/form-p.png'),
          title: '智能表单',
          desc: '便捷的在线信息收集工具，支持手机电脑多端信息同步，随时随地查看收集结果',
          link: 'https://f.wps.cn',
          name: 'form',
          weight: 94,
          event: 'form',
          subicons: []
        }
      ]
    },
    {
      name: 'xietong',
      title: '高效沟通',
      desc: '连接学校中的每一个人',
      subdesc:
        '通过即时通讯、在线会议、校内邮箱等工具，让校内师生、职工在安全的环境中轻松沟通。',
      items: [
        {
          logo: require('@/assets/images/product/xiezuo.svg'),
          reverseLogo: require('@/assets/images/product/xiezuo-r.png'),
          picture: require('@/assets/images/product/xiezuo-p.webp'),
          pngPicture: require('@/assets/images/product/xiezuo-p.png'),
          title: 'WPS协作',
          desc: '组织级专属工作平台，即时通讯+文档协作，专注内外部交流协同，全应用顺畅串联',
          link: 'https://xz.wps.cn',
          name: 'xiezuo',
          weight: 98,
          event: 'woa',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/meeting.svg'),
          reverseLogo: require('@/assets/images/product/meeting-r.png'),
          picture: require('@/assets/images/product/meeting-p.webp'),
          pngPicture: require('@/assets/images/product/meeting-p.png'),
          title: 'WPS会议',
          desc: '适用于学校、教育机构的视频会议解决方案，便捷简单、高性价比，适配多硬件多设备，安全有保障',
          link: 'https://meeting.kdocs.cn',
          name: 'meeting',
          weight: 97,
          event: 'meeting',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/email.svg'),
          reverseLogo: require('@/assets/images/product/email-r.png'),
          picture: require('@/assets/images/product/email-p.webp'),
          pngPicture: require('@/assets/images/product/email-p.png'),
          title: 'WPS邮箱',
          desc: '企业级邮箱解决方案，和文档、联系人深度打通，丝滑的正文编辑和@人体验',
          link: '',
          name: 'email',
          event: 'email',
          subicons: []
        }
      ]
    },
    {
      name: 'kaifang',
      title: '提升效率',
      desc: '简单有序的管理校内资料、事务',
      subdesc:
        '随时随地方便地对校内资料进行存储、共享和协作。借助日历、待办等高效工具，井然有序地管理在校事务。',
      items: [
        {
          logo: require('@/assets/images/product/zhishi.png'),
          reverseLogo: require('@/assets/images/product/zhishi-r.png'),
          picture: require('@/assets/images/product/zhishi-p.webp'),
          pngPicture: require('@/assets/images/product/zhishi-p.png'),
          title: '金山知识管理',
          desc: '全新一代知识管理系统，帮助企业轻松管理知识，赋能业务发展',
          link: 'https://km.wps.cn',
          name: 'knowledge',
          event: 'knowledge',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/yunpan.png'),
          reverseLogo: require('@/assets/images/product/yunpan-r.png'),
          picture: require('@/assets/images/product/yunpan-p.webp'),
          pngPicture: require('@/assets/images/product/yunpan-p.png'),
          title: '企业云盘',
          desc: '企业文件统一存储共享、全链路安全保护，支持100+种格式在线预览，云盘文档可在线编辑',
          link: '',
          weight: 92,
          event: 'cloud',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/rili.png'),
          reverseLogo: require('@/assets/images/product/rili-r.png'),
          picture: require('@/assets/images/product/rili-p.webp'),
          pngPicture: require('@/assets/images/product/rili-p.png'),
          title: 'WPS日历',
          desc: '组织内成员共享日程，一键开启会议群聊，自动关联会议纪要',
          link: 'https://rili.wps.cn',
          name: 'rili',
          event: 'calendar',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/todo.png'),
          reverseLogo: require('@/assets/images/product/todo-r.png'),
          picture: require('@/assets/images/product/todo-p.webp'),
          pngPicture: require('@/assets/images/product/todo-p.png'),
          title: 'WPS待办',
          desc: '简洁高效的团队任务管理工具，与同事和朋友共享任务分组',
          link: 'https://todo.wps.cn',
          name: 'todo',
          event: 'backlog',
          subicons: []
        }
      ]
    },
    {
      name: 'anquan',
      title: '开放生态',
      desc: '开放、互联，为学校创造更大价值',
      subdesc:
        '构建完整的内容、应用、服务生态闭环，基于协作中台、文档中台等能力在教学、办公、管理场景助力学校实现数字化转型。',
      items: [
        {
          logo: require('@/assets/images/product/kaifang.png'),
          reverseLogo: require('@/assets/images/product/kaifang-r.png'),
          picture: require('@/assets/images/product/kaifang-p.webp'),
          pngPicture: require('@/assets/images/product/kaifang-p.png'),
          title: '内容生态',
          desc: '引入高质量合作伙伴内容资源，同时为教育工作者搭建内容分享平台，建设完整内容生态闭环',
          link: '',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/xiezuozhongtai.png'),
          reverseLogo: require('@/assets/images/product/xiezuozhongtai-r.png'),
          picture: require('@/assets/images/product/xiezuo2-p.webp'),
          pngPicture: require('@/assets/images/product/xiezuo2-p.png'),
          title: '协作中台',
          desc: '颗粒化IM能力和IM开源，业务快速融合，快速做出自己的IM产品',
          link: '',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/doc.png'),
          reverseLogo: require('@/assets/images/product/doc-r.png'),
          picture: require('@/assets/images/product/doc-p.webp'),
          pngPicture: require('@/assets/images/product/doc-p.png'),
          title: '文档中台',
          desc: '敏捷统一的集成标准，强大且高兼容性的文档服务，丰富灵活可拓展的开放能力',
          link: '',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/yingyong.png'),
          reverseLogo: require('@/assets/images/product/yingyong-r.png'),
          picture: require('@/assets/images/product/yingyong-p.webp'),
          pngPicture: require('@/assets/images/product/yingyong-p.png'),
          title: '应用生态',
          desc: '协作轻应用数据与企业系统数据对接，为企业数字化赋能',
          link: 'https://co.wps.cn/workbench/?vcl=v2#/team',
          event: 'applied_ecology',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/hezuo.png'),
          reverseLogo: require('@/assets/images/product/hezuo-r.png'),
          picture: require('@/assets/images/product/hezuo-p.webp'),
          pngPicture: require('@/assets/images/product/hezuo-p.png'),
          title: '合作生态',
          desc: '持续引入高质量合作方，完善开发生态，为企业赋能',
          link: 'https://open.wps.cn',
          name: 'hezuo',
          event: 'collaborative_ecology',
          subicons: []
        },
        {
          logo: require('@/assets/images/product/fuwu.png'),
          reverseLogo: require('@/assets/images/product/fuwu-r.png'),
          picture: require('@/assets/images/product/fuwu-p.webp'),
          pngPicture: require('@/assets/images/product/fuwu-p.png'),
          title: '服务生态',
          desc: '覆盖全国全方位的服务体系，提供整体解决方案能力，提升企业数字办公能力',
          link: '',
          subicons: []
        }
      ]
    }
  ]
};

export const eduData = {
  title: '数字化教育平台',
  subtitle:
    '专为国内教育场景打造的数字化解决方案，帮助您的机构简化工作、提升效率',
  introduceList: [
    {
      title: '教学教研',
      desc: '「WPS 365 教育版」为教师提供了丰富的教学工具和教学素材，帮助教师更高效地备课、教学、评估、追踪和分析，省下时间专注于培养学生。',
      icon: eduIcon1,
      pngIcon: eduIcon1png,
    },
    {
      title: '教务管理',
      desc: '协作收集的数据自动汇总、存储、便于高效筛选、复用和导出，通过可视化视图直观呈现，提升数据价值。高效解决校内复杂事务，助力校园管理。',
      icon: eduIcon2,
      pngIcon: eduIcon2png,
    },
    {
      title: '辅助学习',
      desc: '借助知识全生命周期管理方案，帮助学生高效收集、沉淀、管理、使用知识。还有多种易用的学习工具，持续提升学生学习效率。',
      icon: eduIcon3,
      pngIcon: eduIcon3png,
    }
  ]
};

export const secureData = {
  title: '严密的安全管控体系',
  subtitle: '践行5A标准的零信任安全，校内数据有序流转，守护文档全生命周期安全',
  icon: secureIcon0,
  pngIcon: secureIcon0png,
  introduceList: [
    {
      title: '三层安全管控',
      desc: `身份管控｜身份服务践行5A标准的零信任安全<br/>
      文档管控｜从端到云，守护文档全生命周期安全<br/>
      策略管控｜全局防控策略构筑数字办公安全屏障`,
      icon: secureIcon1
    },
    {
      title: '资料安全转移',
      desc: '安全转移毕业学生的文档、权益及学习记录等数据，确保文档资产交接有序，保障学生资产的连续性',
      icon: secureIcon2
    },
    {
      title: '专属域名和IP访问限制',
      desc: '可实现内网禁止个人账号登录，外网访问校内文档受权限限制，形成数据安全屏障',
      icon: secureIcon3
    }
  ]
};

export const customData = {
  title: '更多学校选择WPS 365 教育版',
  list: [
    {
      title: '清华大学',
      icon: ''
    }
  ],
  list1: [
    {
      title: '清华大学',
      icon: require('@/assets/images/home/custom-sch11.png')
    },
    {
      title: '中国人民大学',
      icon: require('@/assets/images/home/custom-sch12.png')
    },
    {
      title: '上海交通大学',
      icon: require('@/assets/images/home/custom-sch13.png')
    },
    {
      title: '武汉大学',
      icon: require('@/assets/images/home/custom-sch14.png')
    },
    {
      title: '山东大学',
      icon: require('@/assets/images/home/custom-sch15.png')
    },
    {
      title: '吉林大学',
      icon: require('@/assets/images/home/custom-sch16.png')
    },
    {
      title: '福州大学',
      icon: require('@/assets/images/home/custom-sch17.png')
    },
    {
      title: '四川大学',
      icon: require('@/assets/images/home/custom-sch18.png')
    },
    {
      title: '厦门大学',
      icon: require('@/assets/images/home/custom-sch19.png')
    },
    {
      title: '复旦大学',
      icon: require('@/assets/images/home/custom-sch110.png')
    },
    {
      title: '中南大学',
      icon: require('@/assets/images/home/custom-sch111.png')
    }
  ],
  list2: [
    {
      title: '中国矿业大学',
      icon: require('@/assets/images/home/custom-zgky.png')
    },
    {
      title: '北京航空航天大学',
      icon: require('@/assets/images/home/custom-sch21.png')
    },
    {
      title: '集美大学',
      icon: require('@/assets/images/home/custom-sch22.png')
    },
    {
      title: '云南大学',
      icon: require('@/assets/images/home/custom-sch23.png')
    },
    {
      title: '华中科技大学',
      icon: require('@/assets/images/home/custom-sch24.png')
    },
    {
      title: '西北工业大学',
      icon: require('@/assets/images/home/custom-sch25.png')
    },
    {
      title: '中国地质大学',
      icon: require('@/assets/images/home/custom-sch26.png')
    },
    {
      title: '大连理工大学',
      icon: require('@/assets/images/home/custom-sch27.png')
    },
    {
      title: '河南职业技术学院',
      icon: require('@/assets/images/home/custom-sch28.png')
    },
    {
      title: '浙江金融职业学院',
      icon: require('@/assets/images/home/custom-sch29.png')
    },
    {
      title: '南京城市职业学院',
      icon: require('@/assets/images/home/custom-sch210.png')
    }
  ]
};

export const subBannerData = {
  title: 'WPS数字化教育解决方案',
  subtitle: '开启WPS 365 教育版，畅享一体化教学办公管理体验',
  icon: '',
  button: {
    label: '联系销售',
    url: common.contactSales
  }
};
